module.exports = __webpack_public_path__ + "static/media/info-circle.1d7ff502.png";